import { Navigate, Outlet } from 'react-router'
import FloatingWhatsapp from '../components/layout/FloatingWhatsapp'
import { useAuth } from '../context/AuthContext'

export default function AuthLayout() {
    const { token } = useAuth()

    if (token) {
        return <Navigate to='/' replace />
    }

    return (
        <>
            <Outlet />
            <FloatingWhatsapp />
        </>
    )
}
